import wixWindow from 'wix-window'; 
$w.onReady(function () { 
if (wixWindow.formFactor === "Mobile"){
let myLang = wixWindow.multilingual.currentLanguage;  
if (myLang === 'he') {
     $w('#hebfooter').expand();
	 $w('#engfooter').collapse();

} else { 
     $w('#hebfooter').collapse();
	 $w('#engfooter').expand();
   }
} else {
	let myLang = wixWindow.multilingual.currentLanguage;  
if (myLang === 'he') {
     $w('#hebfooter').expand();
	 $w('#engfooter').collapse();
      $w('#engmenu').hide();
      $w('#hebmenu').show();

} else { 
     $w('#hebfooter').collapse();
	 $w('#engfooter').expand();
      $w('#engmenu').show();
      $w('#hebmenu').hide();
}
}
});
